import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {NavigationStart, Router} from '@angular/router';

import {AuthService} from './shared/auth/auth.service';
import {UserService} from './shared/user/user.service';
import {User} from './shared/user/model/user.model';
import {Title} from '@angular/platform-browser';
import {PlatformConfig} from './app-loader/platform-config';
import {ConfigLoaderService} from './app-loader/config-loader.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  platformConfig: PlatformConfig;
  constructor(private translate: TranslateService,
              private router: Router,
              private authService: AuthService,
              private userService: UserService,
              private titleService: Title,
              public configLoaderService: ConfigLoaderService) {
    this.platformConfig = this.configLoaderService.getPlatformConfig();
    this.titleService.setTitle(this.platformConfig.platform.callcenterAppTitle);

    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');

    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');

    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          if (event.url !== '/signin' && !authService.isAuthenticated()) {
            this.router.navigate(['/signin']);
          }
        }
      }
    );

    this.userService.currentUser.subscribe(
      (user: User) => {
        if (user === null) {
          this.authService.signOutUser();
          this.router.navigate(['/signin']);
          document.location.reload();
        }
      }
    );

  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/app.component.ts